import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { GalleryComment } from '../models/galleryComment';

type SliceModel = GalleryComment;
const sliceName: string = 'galleryComments';

const currRequests: Set<ModelId> = new Set;

export const fetchGalleryComment = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const galleryCommentAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id,
});
export const galleryCommentSlice = createSlice({
    name: sliceName,
    initialState: galleryCommentAdapter.getInitialState(),
    reducers: {
        addMany: galleryCommentAdapter.addMany,
        addOne: galleryCommentAdapter.addOne,
        updateMany: galleryCommentAdapter.updateMany,
        updateOne: galleryCommentAdapter.updateOne,
        upsertOne: galleryCommentAdapter.upsertOne,
        upsertMany: galleryCommentAdapter.upsertMany,
        removeOne: galleryCommentAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchGalleryComment.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                galleryCommentAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
